import React from 'react';
import { useAuthQuery as useQuery } from '../../../../shared/hooks/useAuthQuery';
import { useNavigate } from 'react-router-dom';
import { api } from '../../../../convex/_generated/api';
import { Spinner } from '../../../../catalyst-components/spinner';
import { CheckCircleIcon, ChatBubbleLeftRightIcon, UserGroupIcon } from '@heroicons/react/24/outline';

export const AssistantCards: React.FC = () => {
  const navigate = useNavigate();
  const stats = useQuery(api.sessions.getAssistantSessionStats, {});

  if (!stats) {
    return (
      <div className="flex justify-center items-center h-64">
        <Spinner />
      </div>
    );
  }

  if (stats.length === 0) {
    return (
      <div className="text-center py-12 text-muted-foreground bg-muted/30 rounded-xl">
        No assistant sessions found
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
      {stats.map((assistant) => (
        <button
          key={assistant.assistantId}
          onClick={() => navigate(`/admin/sessions/assistant/${assistant.assistantId}`)}
          className="text-left p-6 bg-card border-2 border-border/50 rounded-xl hover:border-primary/50 hover:shadow-md transition-all cursor-pointer"
        >
          <h3 className="text-lg font-semibold text-foreground mb-4 truncate">
            {assistant.name}
          </h3>
          <div className="space-y-3">
            <div className="flex items-center gap-2 text-sm">
              <ChatBubbleLeftRightIcon className="h-5 w-5 text-blue-500 shrink-0" />
              <span className="text-muted-foreground">Total Sessions:</span>
              <span className="font-semibold text-foreground ml-auto">{assistant.totalSessions}</span>
            </div>
            <div className="flex items-center gap-2 text-sm">
              <CheckCircleIcon className="h-5 w-5 text-green-500 shrink-0" />
              <span className="text-muted-foreground">Completed:</span>
              <span className="font-semibold text-green-600 ml-auto">{assistant.completedSessions}</span>
            </div>
            <div className="flex items-center gap-2 text-sm">
              <UserGroupIcon className="h-5 w-5 text-orange-500 shrink-0" />
              <span className="text-muted-foreground">In Progress:</span>
              <span className="font-semibold text-orange-600 ml-auto">
                {assistant.totalSessions - assistant.completedSessions}
              </span>
            </div>
          </div>
          {/* Completion bar */}
          <div className="mt-4">
            <div className="w-full bg-muted/50 rounded-full h-2">
              <div
                className="bg-green-500 h-2 rounded-full transition-all"
                style={{
                  width: `${assistant.totalSessions > 0 ? (assistant.completedSessions / assistant.totalSessions) * 100 : 0}%`,
                }}
              />
            </div>
            <p className="text-xs text-muted-foreground mt-1">
              {assistant.totalSessions > 0
                ? `${Math.round((assistant.completedSessions / assistant.totalSessions) * 100)}% completion rate`
                : 'No sessions'}
            </p>
          </div>
        </button>
      ))}
    </div>
  );
};
